import React, { useEffect, useState } from "react";
import "./lohstyle.css";
import ForgitPassPop from "./ForgitPassPop";
import {
  signupapi,
  loginapi,
  socialLoginGoogle,
  socialLoginFacebook,
} from "../../network/api/user";
import { LoginSocialFacebook, LoginSocialGoogle } from "reactjs-social-login";
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
// import "//netdna.bootstrapcdn.com/font-awesome/3.0/css/font-awesome.css";
import { useTranslation } from "react-i18next";

function LogForm() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [username, setusername] = useState("");
  const [telephone, settelephone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [registerErrors, setregisterErrors] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    telephone: "",
  });

  useEffect(() => {
    if (window.google?.accounts?.id) {
      window.google.accounts.id.initialize({
        client_id:
          "21951150250-2enva780tabsgjrgfpk79630pt3t6vdn.apps.googleusercontent.com",
        callback: handleCallbackResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("signInDiv"),
        {
          theme: "outline",
          size: "large",
        }
      );
    }
  }, []);

  const handleCallbackResponse = (response) => {
    socialLoginGoogle({ idToken: response.credential }).then((result) => {
      if (result.result === true) {
        window.location.reload(true);
        dismissModal();
      } else {
        setError(result.response.error);
        setTimeout(() => {
          setError("");
        }, 2000);
      }
    });
  };

  const [first_name, setfirst_name] = useState("");
  const [last_name, setlast_name] = useState("");

  const [positions, setPositions] = useState({
    l: { left: "20px" },
    r: { left: "31rem" },
    b: { left: "180px" },
  });

  const log = () => {
    setPositions({
      l: { left: "-31rem" },
      r: { left: "20px" },
      b: { left: "10px" },
      f: { height: "38rem" },
      m: { marginTop: "1rem", marginButtom: "1rem" },
      bttn1: { color: "#807D7E" },
      bttn2: { color: "#F6F6F6" },
    });
  };

  const reg = () => {
    setPositions({
      l: { left: "20px" },
      r: { left: "31rem" },
      b: { left: "180px" },
      f: { height: "33rem" },
      m: { marginTop: "2.3rem", marginButtom: "2.3rem" },
      bttn1: { color: "#F6F6F6" },
      bttn2: { color: "#807D7E " },
    });
  };


  const handelregister = (e) => {
    e.preventDefault();
    signupapi({
      email,
      username,
      last_name,
      first_name,
      telephone,
      password,
    }).then((result) => {
      if (result.data.success === true) {
        reg();
      } else if (!result.data.success && result.data.errors) {
        setregisterErrors({
          ...registerErrors,
          first_name: result.data.errors.first_name,
          last_name: result.data.errors.last_name,
          username: result.data.errors.username,
          email: result.data.errors.email,
          password: result.data.errors.password,
          telephone: result.data.errors.telephone,
        });
      } else {
        setregisterErrors({ ...registerErrors, email: result.data.message });
      }
    });
  };







  const handellogin = (e) => {
    e.preventDefault();
    loginapi({ email, password })
      .then((result) => {
        if (result === true) {
          window.location.reload();
          dismissModal();
        } else {
          setError("invalid Email OR Password");
          // Clear the message after 2 seconds
          setTimeout(() => {
            setError("");
          }, 2000);
        }
      })
      .catch((err) => {});
  };






  function dismissModal() {
    var dismissButton = document.getElementById("dismissModalButton");
    if (dismissButton) {
      dismissButton.click();
    }
  }



















  
  return (
    <div className="m-0 " style={{ width: "fit-content" }}>
      
      <button
        id="dismissModalButton"
        style={{ display: "none" }}
        data-bs-dismiss="modal"
      ></button>
      <div
        id="Logyou"
        className="form-box overflow-y-auto "
        style={{ minHeight: "33rem", ...positions.f, ...positions.m }}
      >
        <div className="logoptions bg-info   my-0 d-flex juslify-content-b etween m-0 p-0">
        
          <div id="signInDiv"></div>
        </div>

        <div
          className="button-box"
          style={{ marginTop: "2.3rem", ...positions.m }}
        >
          <div id="bttn" style={{ position: "absolute", ...positions.b }}></div>
          <button
            onClick={log}
            type="button"
            className="toggle-btn2 "
            style={{ ...positions.bttn2 }}
          >
            {t("sign")}
          </button>
          <button
            onClick={reg}
            type="button"
            className="toggle-btn "
            style={{ color: "#F6F6F6", ...positions.bttn1 }}
          >
            {t("signIn")}
          </button>
        </div>

        <form
          id="reg"
          style={{ position: "absolute", ...positions.r }}
          className="forms pb-3 pb-lg-0"
          onSubmit={handelregister}
        >
          <input
            placeholder={t("fname")}
            type="text"
            className="my-1 w-100 reginput logininput "
            id="first_name"
            value={first_name}
            onChange={(event) => setfirst_name(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.first_name}</p>

          <input
            placeholder={t("lname")}
            type="text"
            className="my-1 w-100  reginput  logininput   "
            id="last_name"
            value={last_name}
            onChange={(event) => setlast_name(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.last_name}</p>

          <input
            placeholder={t("username")}
            type="text"
            className="my-1 w-100  logininput "
            id="username"
            value={username}
            onChange={(event) => setusername(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.username}</p>

          <input
            placeholder={t("email")}
            type="email"
            className="my-1 w-100 logininput "
            id="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.email}</p>

          <input
            placeholder={t("password")}
            type="password"
            className="my-1 w-100 logininput "
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.password}</p>

          <input
            placeholder={t("phone")}
            type="text"
            className="my-1 w-100 logininput "
            id="telephone"
            value={telephone}
            onChange={(event) => settelephone(event.target.value)}
            required
          />
          <p className="text-danger">{registerErrors.telephone}</p>
          {error && (
            <div className="alert alert-danger text-center  h-25" role="alert">
              {error}
            </div>
          )}
          <button type="submit" className="text-light loginbtn">
            {" "}
            <b>{t("sign")}</b>
          </button>
        </form>

        <form
          id="log"
          style={{ position: "absolute", ...positions.l }}
          className="forms2 forms  "
          onSubmit={handellogin}
        >
          <input
            className="my-1 w-100  logininput "
            type="email"
            id="email"
            value={email}
            placeholder={t("email")}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <input
            className="my-1 w-100 logininput"
            type="password"
            placeholder={t("password")}
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <div className="my-4">
            {error && (
              <div
                className="alert alert-danger text-center  h-25"
                role="alert"
              >
                {error}
              </div>
            )}
            <button className="text-light loginbtn " type="submit">
              <b>{t("signIn")}</b>
            </button>

            <button
              className=" w-100  bg-white forgetpass"
              style={{ border: "none", fontSize: "0.9rem", textAlign: "left" }}
              data-bs-target="#Forgot"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
            >
              {t("forgotPassword")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LogForm;
